import PageContext from '#/app/providers/PageProvider/PageContext';
import { useContext } from 'react';

export const usePage = () => {
  const pageContext = useContext(PageContext);

  return pageContext;
};

export default usePage;
